import React, { useState } from 'react';

import './TagsFilter.scss';
import { TagsField } from 'v5/byModel/tags/TagsField';
import { myServices } from 'v5/services/services.connected.app';
import arrayMove from 'array-move';
import { Checkbox } from '../../../../../../v5/design-system/Checkbox.js';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '../../../../../../v5/design-system/Select.js';
import { useTranslation } from 'react-i18next';

const TagsFilter = ({ param, index, filter, filterChanged, removeFilter }) => {
  const [selectorVisible, setSelectorVisible] = useState(
    !!(filter?.any || filter?.match)
  );
  const { t } = useTranslation(['v1_shared']);
  const handleRangeClicked = () => {
    setSelectorVisible(!selectorVisible);
    if (selectorVisible) {
      removeFilter();
    }
  };

  const tagNames = filter?.any ?? filter?.match ?? [];
  const condition = filter?.match ? 'match' : 'any';

  function applyTags(tags) {
    if (tags.length === 0) {
      removeFilter();
      return;
    }
    filterChanged({
      ...param,
      condition,
      value: tags
    });
  }

  return (
    <div className="ResourceFilter">
      <div
        key={index}
        className="DropdownButton-option"
        onClick={handleRangeClicked}
      >
        <Checkbox
          variant="primaryAlt"
          onClick={handleRangeClicked}
          checked={selectorVisible}
        />
        <span className="DropdownButton-option-label">
          {t(`TagsFilter.${param.label}`)}
        </span>
      </div>
      {selectorVisible && (
        <div className="TagsFilter-content tailwind-root">
          <TagsField
            createButtonOnNewLine
            draggable={false}
            className="w-80"
            allowCreate={false}
            services={myServices}
            tagType="shortlist"
            mode="edit"
            data={filter?.any ?? filter?.match ?? []}
            onAdd={newTag => {
              applyTags([...tagNames, newTag.tag]);
            }}
            addLabel={
              filter?.match?.length === 0
                ? t(`TagsFilter.addTag`)
                : t(`TagsFilter.add`)
            }
            onRemove={({ tag }) => {
              applyTags(tagNames.filter(t => t !== tag));
            }}
            onMove={(from, to) => {
              const tags = arrayMove(tagNames, from, to);
              applyTags(tags);
            }}
          />
          <Select
            value={condition}
            onValueChange={value =>
              filterChanged({
                ...param,
                condition: value,
                value: [...tagNames] // when we don't recreate the array, changes are not detected :(
              })
            }
          >
            <SelectTrigger className="mt-4" size="sm">
              <SelectValue />
            </SelectTrigger>
            <SelectContent align="start">
              <SelectItem value="match">{t('TagsFilter.matchAll')}</SelectItem>
              <SelectItem value="any">{t('TagsFilter.matchAny')}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
};

export default TagsFilter;
